import analytics from "./analytics";

export function reportError(error, metaData) {
  analytics.trackEvent(error.message, metaData);
  console.log(error, metaData);
}
